import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import type ChartView from 'echarts/types/src/view/Chart';
import { installCustomShape } from './shape';
import { installTreeAction } from './twoWayTreeAction';
import TwoWayTreeSeriesModel from './TwoWayTreeSeries';
import TwoWayTreeView from './TwoWayTreeView';
import twoWayTreeLayout from './twoWayTreeLayout';

export function install(registers: EChartsExtensionInstallRegisters) {
  installCustomShape();
  installTreeAction(registers);

  registers.registerSeriesModel(TwoWayTreeSeriesModel);
  registers.registerChartView(TwoWayTreeView as unknown as typeof ChartView);
  registers.registerLayout(twoWayTreeLayout);
}
